export default __webpack_public_path__ + "static/og_image-f76b41e8dd737b0fe4942e0aa254ee8a.png";